module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-dark"
  }, [(_vm.isAllLoaded && !_vm.salarySystem) ? _c('ChooseSalarySystem', {
    attrs: {
      "schoolId": _vm.schoolId
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-sub-header"
  }, _vm._l((_vm.menu), function(item) {
    return _c('p', {
      key: item.key,
      staticClass: "d-sub-header__link",
      class: {
        'd-sub-header__link--active': _vm.activePage === item.key
      },
      on: {
        "click": function($event) {
          return _vm.setActivePage(item.key)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.label) + "\n    ")])
  }), 0), _vm._v(" "), (_vm.isAllLoaded && _vm.activeTab) ? [_c(_vm.activeTab.component, _vm._b({
    tag: "component",
    on: {
      "select": _vm.onTemplateSelected,
      "onTemplateCreated": _vm.onTemplateCreated,
      "onTemplateUpdated": _vm.onTemplateUpdated,
      "onTemplateDeleted": _vm.onTemplateDeleted
    }
  }, 'component', _vm.getPropsFor(_vm.activeTab.key), false))] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41a5a808!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/Salary.vue
// module id = 1877
// module chunks = 1